import { render } from "./CampaignList.vue?vue&type=template&id=18f5cb06&scoped=true"
import script from "./CampaignList.vue?vue&type=script&lang=js"
export * from "./CampaignList.vue?vue&type=script&lang=js"

import "./CampaignList.vue?vue&type=style&index=0&id=18f5cb06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f5cb06"]])

export default __exports__